import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const CustomDomainHeader = props => {
  const { classes } = props
  return (
    <div className={classes.collaborationHeader__root}>
      <Typography
        fontSize="18px"
        fontWeight={500}
        className={classes.title}
        style={{
          padding: '8px 0px',
        }}
      >
        Collaboration
      </Typography>
      <Typography
        variant="body2"
        color={'#637381'}
        className={classes.description}
      >
        Send invitation to work together on collections.
      </Typography>
    </div>
  )
}

export default withStyles(styles)(CustomDomainHeader)
